export default __webpack_public_path__ + "static/media/layers.b8b7810d.svg";